const page = document.querySelector('.page');
const menu = document.querySelector('.menu');

const openButton = menu.querySelector('.menu__control_type_open');
const closeButton = menu.querySelector('.menu__control_type_close');
const links = menu.querySelectorAll('.menu__link');

const toggleMenu = () => {
  page.classList.toggle('page_lock');
  menu.classList.toggle('menu_open');

  if (menu.classList.contains('menu_open')) {
    // Focus on the first link
    links[0].focus();
  } else {
    // Focus on the control
    openButton.focus();
  }
};

openButton.addEventListener('click', () => toggleMenu());
closeButton.addEventListener('click', () => toggleMenu());

links.forEach(link => {
  link.addEventListener('click', () => toggleMenu());
});

window.addEventListener('scroll', () => {
  if (menu.classList.contains('menu_open')) {
    return;
  }
  if (
    window.scrollY > 10 &&
    !openButton.classList.contains('menu__control_highlight')
  ) {
    openButton.classList.add('menu__control_highlight');
  } else if (
    window.scrollY < 10 &&
    openButton.classList.contains('menu__control_highlight')
  ) {
    openButton.classList.remove('menu__control_highlight');
  }
});
